// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"38b2df9f","353":"8df7d6e1","802":"79cffa61"}[chunkId] + ".chunk.css";
};